import React from 'react';
import Translate from 'react-translate-component';

import { notEmpty } from 'utils/ramdaAdditions';

import {
    ApprovalPersonNotification,
    ApprovalProjectNotification
} from 'components/common/notifications/ApprovalNotifications';

const EmptyMessage = ({ closeNotification }) => (
    <div className='notification-link' onClick={closeNotification}>
        <Translate content='notify.emptyList' />;
    </div>
);

export default function Notification ({ notes: { person, project }, ...rest }) {
    const getNotifications = () => notEmpty({ person, project }) ? (
        <div>
            <ApprovalPersonNotification count={person} {...rest} />
            <ApprovalProjectNotification count={project} {...rest} />
        </div>
    ) : <EmptyMessage {...rest} />

    return (
        <div>{ getNotifications() }</div>
    );
}
